<template>
  <div class="c-about-us-wrapper">
    <div class="banner">
      <img :src="banner" alt="" />
    </div>
    <div class="container">
      <section class="company-profile">
        <div class="profile">
          <h2>{{ $t("title.companyProfile") }}</h2>
          <div class="con" v-html="companyProfile.companyFileBody"></div>
        </div>
        <img :src="companyProfile.WebSite" alt="" />
      </section>
      <section class="company-philosophy" v-if="$i18n.locale === 'zh'">
        <p>从零到壹</p>
        <span>公司理念</span>
      </section>
      <section class="company-philosophy" v-else-if="$i18n.locale === 'en'">
        <p>Zero TO One</p>
        <span>Company philosophy</span>
      </section>
      <section class="company-philosophy" v-else>
        <p>De cero a uno</p>
        <span>Filosofía de la empresa</span>
      </section>
      <section class="development-path">
        <h1>{{ $t("title.developmentPath") }}</h1>
        <DevelopmentPathSwiper />
      </section>
      <section class="honor">
        <h1>{{ $t("title.honor") }}</h1>
        <Honor />
      </section>
    </div>
  </div>
</template>

<script>
import DevelopmentPathSwiper from "./components/DevelopmentPath/DevelopmentPath.vue";
import Honor from "./components/Honor/Honor.vue";
export default {
  components: {
    DevelopmentPathSwiper,
    Honor
  },
  data() {
    return {
      banner: "",
      companyProfile: {}
    };
  },
  mounted() {
    const bannerParams = {
      Data: {
        FInterID: 5
      }
    };
    this.$store.dispatch("getIndexBodyData", bannerParams).then(res => {
      this.banner = res.Data.WebSite;
    });

    const params = {
      Data: {
        FInterID: 4
      }
    };

    this.$store.dispatch("getIndexBodyData", params).then(res => {
      this.companyProfile = res.Data;
      if (this.$i18n.locale === "zh") {
        this.companyProfile.companyFileBody = res.Data.Body;
      } else if (this.$i18n.locale === "en") {
        this.companyProfile.companyFileBody = res.Data.EnglishBody;
      } else if (this.$i18n.locale === "sp") {
        this.companyProfile.companyFileBody = res.Data.xibanyaBody;
      }
    });
  },
  methods: {}
};
</script>

<style lang="less">
@import "~@/assets/style/variables.less";
.c-about-us-wrapper {
  .banner {
    width: 100%;
    height: 560px;
    // background: @bgColor;

    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  .container {
    width: 1200px;
    margin: 0 auto 60px;

    .company-profile {
      width: 100%;
      min-height: 600px;
      background: url("../../../../assets/imgs/company-profile-bg.png") top
        center no-repeat;
      background-size: 100% 100%;
      position: relative;

      .profile {
        text-align: left;

        h2 {
          font-size: 48px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: rgba(0, 0, 0, 1);
          line-height: 160px;
        }

        p {
          width: 606px;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 24px;
          color: rgba(0, 0, 0, 1);
        }
      }

      img {
        display: block;
        width: 405px;
        height: 540px;
        position: absolute;
        right: 40px;
        bottom: 0;
      }
    }

    .company-philosophy {
      text-align: left;
      padding: 60px 0;

      p {
        font-size: 40px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #555555;
        margin-bottom: 21px;
      }

      // h2 {
      //   font-size: 36px;
      //   font-family: Microsoft YaHei;
      //   font-weight: 300;
      //   color: rgba(0, 0, 0, 1);
      //   margin-bottom: 45px;
      // }

      span {
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: rgba(0, 0, 0, 1);
        padding-left: 330px;
        position: relative;
      }

      span:before {
        content: "";
        width: 315px;
        height: 1px;
        background: @bgColor;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
      }
    }

    .development-path {
      h1 {
        font-size: 48px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: rgba(0, 0, 0, 1);
      }
    }

    .honor {
      h1 {
        font-size: 48px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: rgba(0, 0, 0, 1);
        margin-bottom: 60px;
      }
    }
  }
}
</style>
